import { Container } from "./styles";
import VinayakSingh from "../../assets/VinayakSingh.png";

import HeroSctionImg from "../../assets/HeroSctionImg.png";



import wordpress from "../../assets/wordpress.svg";

import shopify from "../../assets/shopify.svg";

import htmlIcon from "../../assets/html-icon.svg";
import cssIcon from "../../assets/css-icon.svg";
import jsIcon from "../../assets/js-icon.svg";
import reactIcon from "../../assets/react-icon.svg";
import nodeIcon from "../../assets/node-icon.svg";
import MongoLogo from "../../assets/mongodb.svg"
import JavaLogo from "../../assets/JavaLogo.svg"
import SpringLogo from "../../assets/SpringLogo.png"
import PostgresqlLogo from "../../assets/PostgresqlLogo.svg"
import TailwindLogo from "../../assets/TailwindLogo.png";


import typescriptIcon from "../../assets/typescript-icon.svg";

import boostrapIcon from "../../assets/bootstrap-icon.svg";
import ScrollAnimation from "react-animate-on-scroll";

export function About() {
  return (
    <Container id="about">
      <div className="about-text">
        <ScrollAnimation animateIn="fadeInLeft">
          <h2>About me</h2>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={0.1 * 1000}>
          <p>
          I bring a passion for software development and expertise in Java, JavaScript, Spring Boot, and React.js. My strengths include building dynamic web applications, securing systems with Spring Security, and creating reliable databases with PostgreSQL. With a keen eye for clean code and front-end design using HTML and CSS, I ensure that every project I work on is both functional and visually appealing.
          </p>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={0.2 * 1000} style={{ marginTop: "2rem", marginBottom: "2rem" }}>
          <p>
          Specializing in back-end development, I follow best coding practices to create scalable, high-performance solutions. My computer science knowledge allows me to implement systems that meet the demands of fast-paced environments while maintaining robustness and efficiency. Whether it's optimizing code or integrating complex functionalities, I am dedicated to delivering high-quality software.</p>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={0.3 * 1000}>
          <p>
          I enjoy working in collaborative team settings and leverage my strong communication skills to contribute effectively to project success. My ability to articulate ideas clearly and work closely with others ensures that development projects run smoothly from start to finish. Through teamwork and dedication, I strive to achieve the best possible outcomes in every web development project I undertake.</p>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={0.4 * 1000}>
          <h3>Here are my main skills:</h3>
        </ScrollAnimation>
        <div className="hard-skills">
        <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.17 * 1000}>
              <img src={htmlIcon} alt="Html" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.18 * 1000}>
              <img src={cssIcon} alt="Css" />
            </ScrollAnimation>
          </div>

          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.19 * 1000}>
              <img src={jsIcon} alt="JavaScript" />
            </ScrollAnimation>
          </div>

          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.13 * 1000}>
              <img src={reactIcon} alt="React" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.15 * 1000}>
              <img src={TailwindLogo} alt="TailwindLogo" />
            </ScrollAnimation>
          </div>




          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.16 * 1000}>
              <img src={nodeIcon} alt="Node" />
            </ScrollAnimation>
          </div>



        



          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.10 * 1000}>
              <img src={JavaLogo} alt="JavaLogo" />
            </ScrollAnimation>
          </div>
          
          
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.14 * 1000}>
              <img src={SpringLogo} alt="SpringLogo" />
            </ScrollAnimation>
          </div>

          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.12 * 1000}>
              <img src={MongoLogo} alt="MongoLogo" />
            </ScrollAnimation>
          </div>
   
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.19 * 1000}>
              <img src={PostgresqlLogo} alt="PostgresqlLogo" />
            </ScrollAnimation>
          </div>
          
        </div>
      </div>
      <div className="about-image">
        <ScrollAnimation animateIn="fadeInRight" delay={0.20 * 1000}>
          <img src={HeroSctionImg} alt="Image" />
        </ScrollAnimation>
      </div>
    </Container>
  )
}
